import {
    Box,
    Checkbox,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@mui/material';
import React, { ReactElement } from 'react';

export const SharedItemUI = ({
    title,
    subtitle = '',
    onCheck,
    isChecked = false,
    children = <></>,
    enabled = true,
    checkboxVisible = true,
    icon,
    className: classNameProp,
}: {
    title: string;
    subtitle?: string | ReactElement;
    onCheck: (event: React.SyntheticEvent, checked: boolean) => void;
    isChecked?: boolean;
    children?: React.ReactNode;
    enabled?: boolean;
    checkboxVisible?: boolean;
    icon: React.ReactNode;
    className?: string;
}): React.ReactElement => (
    <Box
        className={classNameProp}
        style={{ display: 'flex', flexDirection: 'column' }}
    >
        <ListItem>
            <ListItemIcon>
                {checkboxVisible && (
                    <Checkbox
                        data-testid="checkbox_setstate"
                        checked={isChecked}
                        onChange={onCheck}
                        color="primary"
                        disabled={!enabled}
                    />
                )}
            </ListItemIcon>
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText primary={title} secondary={subtitle} />
        </ListItem>
        <div style={{ paddingLeft: '9.375rem', paddingRight: '9.375rem' }}>
            {enabled && children}
        </div>
    </Box>
);
